export const RECEIVE_ALERT_DATA = "RECEIVE_ALERT_DATA";
export const SHOW_LOADER = "SHOW_ALERT_SERVICE_LOADER";

export interface IAlertState {
    alertData?: AlertData;
    isAlertLoading: boolean;
}

export interface AlertData {
    alertList: any;
}

export interface GetAlertDataAction {
    type: "RECEIVE_ALERT_DATA";
    alertData: AlertData;
}
export interface ShowAction {
    type: "SHOW_ALERT_SERVICE_LOADER";
    isAlertLoading: boolean;
}

export type KnownAction = GetAlertDataAction | ShowAction;
